/**
 * @Description: 耗材的信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https, { axiosHttpPost } from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  MaterialModel,
  MaterialSearchModel,
  MaterialPageSearchModel,
  // MaterialAddModel,
  // MaterialUpdateModel,
  IdsModel,
  AddTagsModel,
  MaterialTagsModel
} from '@/model/product/MaterialModel'

const baseUrl = Route.product + '/material'

/**
 * 搜索分页数据
 */
export const pageSearchMaterial = (param: MaterialPageSearchModel) => {
  return https().request<RootObject<PageRespModel<MaterialModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchMaterial = (param: MaterialSearchModel) => {
  return https().request<RootObject<MaterialModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getMaterial = (id: number) => {
  return https().request<RootObject<MaterialModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addMaterial = (param: FormData) => {
  // return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
  return axiosHttpPost(baseUrl.concat('/add'), param, ContentType.multipart)
}

/**
 * 更新数据
 */
export const updateMaterial = (param: FormData) => {
  // return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
  return axiosHttpPost(baseUrl.concat('/update'), param, ContentType.multipart)
}

/**
 * 删除数据
 */
export const removeMaterial = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveMaterial = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}

/**
 * 添加tag数据
 */
export const addMaterialTags = (param: AddTagsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add/tags'), Method.POST, param, ContentType.json)
}

/**
 * 删除tag数据
 */
export const removeMaterialTags = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/tags/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 获取关联tag数据
 */
export const getMaterialTags = (id: number) => {
  return https().request<RootObject<MaterialTagsModel[]>>(baseUrl.concat('/get/tags/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}
